function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "a",
  x: 0,
  y: 0,
  width: 76.449,
  height: 46.706,
  rx: 1.818
}), /*#__PURE__*/React.createElement("rect", {
  id: "b",
  x: 0,
  y: 0,
  width: 52.273,
  height: 46.706,
  rx: 1.818
}), /*#__PURE__*/React.createElement("mask", {
  id: "c",
  maskContentUnits: "userSpaceOnUse",
  maskUnits: "objectBoundingBox",
  x: 0,
  y: 0,
  width: 76.449,
  height: 46.706,
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("mask", {
  id: "d",
  maskContentUnits: "userSpaceOnUse",
  maskUnits: "objectBoundingBox",
  x: 0,
  y: 0,
  width: 52.273,
  height: 46.706,
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: ".246%",
  y1: "0%",
  x2: "99.754%",
  y2: "100%",
  id: "e"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BAFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007CFF",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#E3E9F0",
  opacity: 0.6,
  x: 9.091,
  y: 53.541,
  width: 90.909,
  height: 3.418,
  rx: 1.709
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(16.9 10.253)",
  stroke: "#B3BECD"
}, /*#__PURE__*/React.createElement("use", {
  mask: "url(#c)",
  strokeWidth: 2.273,
  fill: "#F5F8FA",
  strokeDasharray: "2.27272731917245,1.136363659586225",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("use", {
  mask: "url(#d)",
  strokeWidth: 2.273,
  fill: "#FFF",
  strokeDasharray: "2.27272731917245,1.136363659586225",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeWidth: 1.136
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.758 26.212l6.428-6.444M29.186 26.212l-6.428-6.444"
}))), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#FFF",
  opacity: 0.6,
  cx: 18.308,
  cy: 11.765,
  rx: 9.858,
  ry: 9.883
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.685 0C18.138 0 23.37 5.244 23.37 11.714c0 2.63-.866 5.06-2.327 7.015l8.513 8.533a1.676 1.676 0 010 2.367 1.666 1.666 0 01-2.36 0l-8.513-8.534a11.614 11.614 0 01-6.998 2.332C5.23 23.427 0 18.183 0 11.714 0 5.244 5.231 0 11.685 0zm0 3.347c-4.61 0-8.346 3.746-8.346 8.367 0 4.62 3.736 8.367 8.346 8.367 4.61 0 8.346-3.746 8.346-8.367s-3.737-8.367-8.346-8.367z",
  fill: "url(#e)",
  transform: "matrix(-1 0 0 1 30.045 0)"
}));

function SvgErrorGenericSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 57,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(SvgErrorGenericSmall);
export default __webpack_public_path__ + "static/media/error-generic-small.813b99cf.svg";
export { ForwardRef as ReactComponent };